<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('vulnerabilities-list')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/vulnerability/assessments" class="d-inline-block position-relative">
                    {{t('Management')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('vulnerabilities-list')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Vulnerabilities -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('vulnerability')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            <mat-card-title>
                @if (vulnerabilityAssessment) {
                {{vulnerabilityAssessment.branchOffice.company.name}} - {{vulnerabilityAssessment.assessmentName}}
                }
            </mat-card-title>
            <mat-card-subtitle>
                @if (roleName == internal && vulnerabilityAssessmentId) {
                <a mat-button class="add-new-btn"
                    routerLink="/vulnerability/create-vulnerability/{{vulnerabilityAssessmentId}}">
                    + {{t('add-new-vulnerability')}}
                </a>
                }
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive" #TABLE>
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('name')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.vulnerabilityAssessmentResult.name.length > 40) {
                                {{row.vulnerabilityAssessmentResult.name.slice(0,40)}}<br>
                                {{row.vulnerabilityAssessmentResult.name.slice(40,80)}}
                                } @else {
                                {{row.vulnerabilityAssessmentResult.name}}
                                }
                            </td>
                        </ng-container>

                        <!-- Description Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('description')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.vulnerabilityAssessmentResult.description.length > 60) {
                                {{row.vulnerabilityAssessmentResult.description.slice(0,60)}}<br>
                                {{row.vulnerabilityAssessmentResult.description.slice(60,120)}}
                                } @else {
                                {{row.vulnerabilityAssessmentResult.description}}
                                }
                            </td>
                        </ng-container>

                        <!-- Impact Column -->
                        <ng-container matColumnDef="impact">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('impact')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.vulnerabilityAssessmentResult.impact.length > 50) {
                                {{row.vulnerabilityAssessmentResult.impact.slice(0,50)}}<br>
                                {{row.vulnerabilityAssessmentResult.impact.slice(50,100)}}
                                } @else {
                                {{row.vulnerabilityAssessmentResult.impact}}
                                }
                            </td>
                        </ng-container>

                        <!-- Ip Column -->
                        <ng-container matColumnDef="ip">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('ip')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.asset?.ip}}
                            </td>
                        </ng-container>

                        <!-- severityLevel Column -->
                        <ng-container matColumnDef="severityLevel">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('severity-level')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <p [style.color]="row.color">{{row.severityLevelName}}</p>
                            </td>
                        </ng-container>

                        <!-- State Column -->
                        <ng-container matColumnDef="state">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('state')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.state.name}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button
                                        routerLink="/vulnerability/view-evidences/{{vulnerabilityAssessmentId}}/{{row.vulnerabilityAssessmentResult.id}}"
                                        matTooltip="{{t('view')}} {{t('evidences')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            visibility
                                        </i>
                                    </a>
                                    @if (roleName == internal || roleName == supervisor) {
                                    <button type="button" mat-button
                                        (click)="showCompanyUser(row.vulnerabilityAssessmentResult.id)"
                                        matTooltip="{{t('assign')}} {{t('user')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            person
                                        </i>
                                    </button>
                                    }
                                    <a mat-button
                                        routerLink="/vulnerability/manage-vulnerability/{{vulnerabilityAssessmentId}}/{{row.vulnerabilityAssessmentResult.id}}"
                                        matTooltip="{{t('manage')}} {{t('vulnerability')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            enterprise
                                        </i>
                                    </a>
                                    <a mat-button
                                        routerLink="/vulnerability/edit-vulnerability/{{vulnerabilityAssessmentId}}/{{row.vulnerabilityAssessmentResult.id}}"
                                        matTooltip="{{t('edit')}} {{t('vulnerability')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </a>
                                    @if (roleName == internal) {
                                    <button type="button" mat-button
                                        (click)="delete(row.vulnerabilityAssessmentResult.id)"
                                        matTooltip="{{t('delete')}} {{t('vulnerability')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
                <button mat-raised-button color="altair" (click)="exportTOExcel()">{{t('export-as-excel')}}</button>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Popup -->
    <div class="assign-company-user-popup" [class.active]="classApplied"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <div class="popup-dialog">
            <mat-card class="altair-card mb-25 border-radius bg-white border-none d-block">
                <mat-card-header>
                    <mat-card-title>
                        <h5 class="mt-0 mb-0">
                            {{t('assign')}} {{t('user')}}
                        </h5>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <button mat-button (click)="toggleClass()">
                            <i class="ri-close-fill"></i>
                        </button>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="assignCompanyUserForm">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-selection-list formControlName="companyUser" [(ngModel)]="selectedUser"
                                    multiple="false">
                                    @for (companyUser of companyUsersList; track companyUser) {
                                    <mat-list-option value="{{companyUser.id}}">{{companyUser.name}}
                                        ({{companyUser.email}})</mat-list-option>
                                    }
                                </mat-selection-list>
                            </div>
                        </div>
                        <div class="btn-box">
                            <button mat-button type="button" (click)="assignCompanyUser()"
                                [disabled]="assignCompanyUserForm.invalid">
                                {{t('save')}}
                            </button>
                            <button mat-button (click)="toggleClass()">
                                {{t('cancel')}}
                            </button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

</ng-container>
